export function validateContact(contact) {
    const value = (contact || '').trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^\+?\d{7,15}$/;
    if (!value) {
        return 'contact_required';
    } else if (!emailPattern.test(value) && !phonePattern.test(value)) {
        return 'contact_invalid';
    }
    return '';
}

export function validateForm(form) {
    if (!form.suggestion || !form.suggestion.trim()) {
        return { valid: false, message: 'suggestion_required' };
    }
    if (!form.name || !form.name.trim()) {
        return { valid: false, message: 'name_required' };
    }
    if (form.canContact) {
        const contactError = validateContact(form.contact);
        if (contactError) {
            return { valid: false, message: contactError };
        }
    }
    if (!form.frequency) {
        return { valid: false, message: 'frequency_required' };
    }
    return { valid: true };
}